var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-nav',{staticClass:"navbar-top navbar-expand",class:{'navbar-dark': _vm.type === 'default'},attrs:{"container-classes":"container-fluid"}},[_c('a',{staticClass:"h4 mb-0 text-white text-uppercase d-none d-lg-inline-block active router-link-active",attrs:{"href":"#","aria-current":"page"}},[_vm._v(" "+_vm._s(_vm.$route.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }